const initialState = {
  accounts: {
    accounts: [],
    count: 0,
  },
  tags: null,
  sites: [],
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_ACCOUNT_DATA":
      return {
        ...state,
        accounts: action.payload,
      };
    case "UPDATE_TAGS":
      return {
        ...state,
        tags: action.payload,
      };
    case "UPDATE_SITES":
      return {
        ...state,
        sites: action.payload,
      };
    default:
      return state;
  }
};

export default accountReducer;
